import {Injectable, inject} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router';
import {AuthenticationService} from '../_services/authentication.service';
import {first, mergeMap} from 'rxjs/operators';
import {GuiPermissionsService} from '../_services/gui/gui-permissions.service';
import {Observable, of} from 'rxjs';

/**
 * A Guard specific to the Login page.  It will check if a user is already logged in, and if so: redirect them to their home page.
 */
@Injectable({
  providedIn: 'root'
})
export class LoginGuard  {
  private readonly authenticationService = inject(AuthenticationService);
  private readonly guiPermissionsService = inject(GuiPermissionsService);


  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean|UrlTree> {
    // If they AREN'T logged in (but trying to view login page) forward them off to their home page
    return this.authenticationService.isUserLoggedIn$.pipe(
      first(),
      mergeMap(isLoggedIn => isLoggedIn ? this.guiPermissionsService.companyAdminRedirectUrlTree$ : of(true))
    );
  }

}
